// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";

const AdminAccountListApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/account_list";

    // API実行, page
    const ExecAdminAccountListApi = async (page) => {

        // 必要なリクエストを定義
        const requestParams = {
            page: page,
        };

        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url:url, requestParams:requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminAccountListApi;
};

export default AdminAccountListApi;
